<atx-product-card-header
  [product]="product"
  [showMarkup]="showMarkup"
  [compactView]="compactView"
  [idFields]="idFields$ | async"
  [titleFields]="titleFields$ | async"
  [titlePrefixFields]="titlePrefixFields$ | async"
  [showWspdPrice]="showWspdPrice$ | async"
  [showWholeSalePrice]="showWholeSalePrice$ | async"
  [isSearchV2Enabled]="isSearchV2Enabled"
  [prices]="prices"
  [showProductTitle]="showProductTitle"
></atx-product-card-header>
